import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Icon } from '../Icon/Icon';
import { changePhoneNumber } from './lib/functions';
import css from './Phone.sass';

var Phone = function Phone(_ref) {
  var className = _ref.className,
      isWhite = _ref.isWhite,
      isBlue = _ref.isBlue,
      isCompact = _ref.isCompact,
      size = _ref.size,
      phoneNumber = _ref.phoneNumber,
      showIcon = _ref.showIcon;
  return React.createElement("a", {
    href: "tel:".concat(phoneNumber),
    className: cx(css.root, className, isWhite && css.white, isBlue && css.blue, isCompact && showIcon && css.compact, size && css[size])
  }, showIcon && React.createElement(Icon, {
    name: "phone",
    className: css.icon
  }), !isCompact ? React.createElement("span", {
    className: css.number
  }, changePhoneNumber(phoneNumber)) : React.createElement("span", {
    className: css.numberEmpty
  }, "\xA0"));
};

Phone.defaultProps = {
  size: 'm',
  phoneNumber: '88005008011',
  showIcon: true
};
var string = PropTypes.string,
    bool = PropTypes.bool,
    oneOf = PropTypes.oneOf;
Phone.propTypes = {
  /**
   * Class name
   */
  className: string,

  /**
   * Defines white theme for dark backgrounds
   */
  isWhite: bool,

  /**
   * Defines blue theme
   */
  isBlue: bool,

  /**
   * Defines component style withought text, showIcon must be true
   */
  isCompact: bool,

  /**
   * Show icon
   */
  showIcon: bool,

  /**
   * Size. Can be: inherit, s, m, l
   * ```inherit``` - use inherit style for phone number, you can use this in Text or another cases
   */
  size:
  /*#__PURE__*/
  oneOf(['inherit', 'l', 'lm', 'm', 's']),

  /**
   * Phone number
   * */
  phoneNumber: string
};
export { Phone };